export default __webpack_public_path__ + "static/media/ladder_right.57972102.png";